import { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { Flex } from 'components/Flex';
import { NewView } from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/CustomersSettingsPage.new.component';
import { EditView } from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/CustomersSettingsPage.edit.component';
import { ReadView } from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/CustomersSettingsPage.read.component';
import { CustomersSettingsPageDataProvider } from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/CustomersSettingsPage.data.context';

const CustomersSettingsPageComponent: FC = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.path}`} component={ReadView} />
      <Route exact path={`${match.path}/new`} component={NewView} />
      <Route exact path={`${match.path}/:customerId/edit`} component={EditView} />
    </Switch>
  );
};

export const CustomersSettingsPage: FC = () => {
  return (
    <CustomersSettingsPageDataProvider>
      <Flex flexDirection="column" padding="0 160px 0 0">
        <CustomersSettingsPageComponent />
      </Flex>
    </CustomersSettingsPageDataProvider>
  );
};
